/**
 * iframe-resize.helper.ts
 *
 * Observa los cambios de tamaño del body y envía mensajes al host
 * para actualizar la altura del iframe embebido.
 */

export class IframeResizeHelper {
  private observer?: ResizeObserver;
  private lastHeight = 0;
  private rafId?: number;
  private isDestroyed = false;

  constructor(private readonly throttleMs = 150) {}

  init(): void {
    if (this.isDestroyed) return;

    // Crea el observer
    this.observer = new ResizeObserver(() => {
      this.onResize();
    });

    // Empieza a observar el body
    this.observer.observe(document.body);

    // Envía el tamaño inicial
    this.postHeight();
  }

  private onResize(): void {
    if (this.rafId) cancelAnimationFrame(this.rafId);

    // Throttling usando requestAnimationFrame + timeout
    this.rafId = requestAnimationFrame(() => {
      setTimeout(() => this.postHeight(), this.throttleMs);
    });
  }

  private postHeight(): void {
    if (this.isDestroyed) return;

    const newHeight = document.body.scrollHeight;

    // Evita enviar mensajes innecesarios
    if (Math.abs(newHeight - this.lastHeight) > 2) {
      this.lastHeight = newHeight;
      window.parent.postMessage({ type: 'sc:resize', height: newHeight }, '*');
    }
  }

  destroy(): void {
    this.isDestroyed = true;
    if (this.observer) this.observer.disconnect();
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }
}
